import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";
import {OpsApp} from "./OpsApp";
import "./styles.css";
import "./enhancements.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {location.pathname.startsWith("/ops") ? <OpsApp /> : <App />}
  </StrictMode>,
);
